<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item>
        <el-button type="primary" size="medium" @click="openDialog('admin')">+&nbsp;创建管理员</el-button>
        <el-button type="primary" size="medium" @click="openDialog('partner')">+&nbsp;创建合作方账号</el-button>
        <el-button :type="allSelectedIds.length ? 'primary' : 'info'" :disabled="allSelectedIds.length ? false : true" size="medium" @click="delectUser">批量删除</el-button>
      </el-form-item>
    </el-form>

    <el-table ref="checktableData" :data="list" v-loading="listLoading" @selection-change="handleSelectionChange" :reserve-selection="true" center height="60vh">
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column label="编号" type="index" width="60"></el-table-column>
      <el-table-column label="角色" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.role}}</template>
      </el-table-column>
      <el-table-column label="用户名" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.username}}</template>
      </el-table-column>
      <el-table-column label="姓名" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.fullname}}</template>
      </el-table-column>
      <el-table-column label="手机号" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.phone}}</template>
      </el-table-column>
      <el-table-column label="邮箱" min-width="100" align="center">
        <template slot-scope="scope">{{scope.row.email}}</template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="goEdit(scope.row.id)">查看</el-button>
          <el-button type="text" @click="delectUser(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes,prev, pager, next,jumper" :current-page.sync="search.pageNum" :page-size="search.pageSize" :page-sizes="[10,20]" :total="total">
      </el-pagination>
    </div>

    <el-row type="flex" justify="end" class="row-bg">
      <el-col :span="5">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirm">确认</el-button>
      </el-col>
    </el-row>

    <el-dialog title="账户创建" :visible.sync="dialogVisible" width="400px" top="32vh" center>
      <div>
        <el-row type="flex" justify="center" class="excelBtn">
          <el-col :span="8" class="font-blod">下载excel模版</el-col>
          <el-col :span="8">
            <el-button type="primary" @click="download">
              <div class="btnclass">
                <img src="../../assets/download.png" alt="">
                <span>excel模版下载</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" class="excelBtn">
          <el-col :span="8" class="font-blod">导入excel</el-col>
          <el-col :span="8">
            <file-upload ref="fileupload" @addUpload="importUpdateStockByExcel" :title="'+导入账户'" :limit="1" />
          </el-col>
        </el-row>
      </div>
      <div slot="footer" class="tableBtn">
        <div @click="cancelExcel()">取 消</div>
        <div @click="submitExcel()">确认导入</div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/Upload/fileUpload';
export default {
  name: 'home',
  components: { FileUpload },
  data() {
    return {
      list: [],
      search: {
        pageSize: 10,
        pageNum: 1,
      },
      isEdit: false,
      listLoading: false,
      // 选中过的页码
      selectedPageNums: [],
      // 选中也所有的数据
      selectedAllData: [],
      // 是否全选中
      allChecked: false,
      allSelectedIds: [],
      unSelectedIds: [],// 所有未选中的id
      oldarr: [],
      arr: [],
      total: 0,
      dialogVisible: false,
      loading: false,
      upLoadData: {},
      key: '',
      dialogType:'',//partner，admin
    }
  },
  filters: {
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.query.key) {
        vm.key = from.query.key
        vm.getList()
      }
    });
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$refs.fileupload.$refs.upload.clearFiles()
      }
    }
  },
  created() {
    // this.getList()
    // console.log(this.$route, "route")
  },
  methods: {
    getList() {
      let { pageSize, pageNum, } = this.search || ''
      let params = {
        key: this.key,
        pageSize: pageSize,
        pageNum: pageNum,
      }
      this.HttpService.post('/autoapp-recovery-server-auth/api/recoveryManage/getManageImportList', params).then(res => {
        if (res.statusCode === 200)
          this.total = res.total
        this.arr = res.data
        this.list = this.arr.slice(0, this.search.pageSize)
      })
    },
    importUpdateStockByExcel(item) {
      this.loading = true;
      this.upLoadData = item
    },
    submitExcel() {
      if (!this.global.handleEmptyData(this.upLoadData)) {
        let formData = new FormData();
        formData.append("file", this.upLoadData.file);
        let url = `/autoapp-recovery-server-auth/api/recoveryManage/manageImport?type=${this.dialogType === 'partner' ? 2:1}`
        this.HttpService.post(url, formData).then(res => {
          if (res.statusCode === 500) {
            this.$message.error(res.message)
          } else {
            this.$message.success('导入成功')
            this.key = res.data
            this.getList()
          }
        })
        this.cancelExcel()
      } else {
        this.$message.error('请上传文件')
      }
    },
    cancelExcel() {
      this.dialogVisible = false
      this.key = ''
    },
    confirm() {
      let params = {

      }
      if (this.key) {
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryManage/manageTrueImport/${this.key}`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('创建成功，批量创建的账号初始密码为：gree8888')
            this.key = ''
            this.getList()
          }
        })
      } else {
        this.$message.error('请导入管理员文件')
      }
    },
    cancel() {
      if (this.key) {
        this.list = []
        this.key = ''
      } else {
        this.$message.error('暂时没有新建管理员')
      }
    },
    download() {
      let url = '/autoapp-recovery-server-auth/api/recoveryManage/downloadManageTemp'
      let title = '管理员账号模板'
      // if (this.dialogType === 'partner'){
      //   url = '/autoapp-recovery-server-auth/api/tbl-partner-management/downloadImportTemplate'
      // }
      this.global.exportExcel(url, {}, title).catch((res) => {
        let blob = new Blob([res.response.data], {
          type: 'application/json',
        });
        var blobReader = new Response(blob).json();
        blobReader.then((res) => {
          this.$message.error(res.message);
        });
      });
    },
    handleSelectionChange(rows) {
      // console.log(rows);
      // this.allSelectedIds 所有页选中的数据
      // this.currentTableData  当前页所有的数据
      // selectedIds  选中的项
      // unSelectedIds  未选中的项
      const selectedIds = rows.map((item) => item.id);
      const unSelectedIds = this.list
        .map((item) => item.id)
        .filter((item) => !selectedIds.includes(item));
      // // 获的所有选中的项
      this.allSelectedIds = this.allSelectedIds.filter(
        (item) => !unSelectedIds.includes(item)
      );
      // // //获得未选中的项
      this.unSelectedIds = unSelectedIds
      // // 数组去重
      this.allSelectedIds = [
        ...new Set([...this.allSelectedIds, ...selectedIds]),
      ];
      console.log(this.allSelectedIds, "this.allSelectedIds")
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList()
    },
    handleCurrentChange() {
      // this.oldarr = this.oldarr.concat(this.unSelectedIds)
      // this.unSelectedIds = [...new Set(this.oldarr)]
      this.getList()
    },
    delectUser(id) {
      this.global.confirm('是否要删除此账号，删除后不可恢复！', () => {
        let params = {
          key: this.key,
          ids: this.allSelectedIds.length ? this.allSelectedIds : [id]
        }
        this.HttpService.post(`/autoapp-recovery-server-auth/api/recoveryManage/delBatchManageImportByIds`, params).then(res => {
          if (res.statusCode === 200) {
            this.$message.success('删除成功')
            this.allSelectedIds = []
          }
          this.getList()
        })
      })

    },
    goEdit(id) {
      this.$router.push({
        path: "/user/userEdit",
        query: {
          id: id,
          type: 'system',
          check: true,
          key: this.key,
        }
      });
    },
    openDialog(type){
      this.dialogVisible = true
      this.dialogType = type
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.row-bg {
  width: 100%;
}
.excelBtn {
  padding: 10px 0;
  display: flex;
  align-items: center;
}
.btnclass {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/adminAdd.vue